import { z } from "zod";
import {
  fileSizeValidator,
  fileTypeValidator,
  VehicleInsuranceFileSchema,
  VehiclePhotoFileSchema,
} from "./file";

export const SERVICES_OPTIONS = [
    { label: "Breakdown Recovery", value: "breakdown_recovery" },
    { label: "Accident Recovery", value: "accident_recovery" },
    { label: "Vehicle Transportation", value: "vehicle_transportation" },
    { label: "Pull Out", value: "pull_out" },
    { label: "Jump Start", value: "jump_start" },
    { label: "Mobile Tyre Fitting", value: "mobile_tyre_fitting" },
    { label: "Mobile Mechanics", value: "mobile_mechanics" },
    { label: "Vehicle Storage", value: "vehicle_storage" },
    { label: "Auto Locksmith", value: "auto_locksmith" },
    { label: "Vehicle Inspection/Diagnostics", value: "vehicle_inspection_diagnostics" },
    { label: "Mobile Battery Fitting", value: "mobile_battery_fitting" },
    { label: "Vehicle Diagnostics", value: "vehicle_diagnostics" },
    { label: "Mobile Valet", value: "mobile_valet" },
    { label: "Emergency Fuel Delivery", value: "out_of_fuel" },
    { label: "Wrong Fuel / Misfuel", value: "misfuel" },
    { label: "AdBlue / Severe Contamination", value: "adblue_contamination" },
];

export const EQUIPMENT_OPTIONS = [
    { label: "Winch", value: "winch" },
    { label: "Skates", value: "skates" },
    { label: "Tilt Slide", value: "tilt_slide" },
    { label: "Low Angle Loading", value: "low_angle_loading" },
    { label: "Jump Pack", value: "jump_pack" },
    { label: "Tyre Fitting Kit", value: "tyre_fitting_kit" },
    { label: "Battery Kit", value: "battery_kit" },
];

const vehicleBaseSchema = z.object({
    registration_number: z.string({ message: "Registration number is required" }).min(1, "Registration number is required"),
    vehicle_type: z.enum(["under_3.5t", "3.5-7.5t", "over_7.5t"], {
        message: "Vehicle category is required",
    }),
    make: z.string({ message: "Vehicle make is required" }),
    model: z.string({ message: "Vehicle model is required" }),
    vin: z.string().optional(),
    year: z.coerce.number<number>({ message: "Vehicle year is required" }).nullable(),
    mileage: z.string().optional(),
    equipment: z.array(z.string()).optional(),
    services_enabled: z
        .array(z.string())
        .min(1, { message: "At least one service must be selected" }),

    vehicle_photo: VehiclePhotoFileSchema.refine(fileSizeValidator, "Max image size is 5MB."),
    vehicle_insurance: VehicleInsuranceFileSchema.refine(fileSizeValidator, "Max image size is 5MB."),
});

export const vehicleSchema = vehicleBaseSchema
    .refine((data) => fileTypeValidator(data.vehicle_photo), {
        message: "Only .jpg, .jpeg, .png, .pdf, and .webp formats are accepted.",
        path: ["vehicle_photo"],
    })
    .refine((data) => fileTypeValidator(data.vehicle_insurance), {
        message: "Only .jpg, .jpeg, .png, .pdf, and .webp formats are accepted.",
        path: ["vehicle_insurance"],
    });

export type VehicleData = z.infer<typeof vehicleSchema>;

export const editVehicleSchema = vehicleBaseSchema.omit({
    vehicle_photo: true,
    vehicle_insurance: true,
});

export type EditVehicleData = z.infer<typeof editVehicleSchema>;
